<template>
  <div>
    <div class="contacts">
      <div class="footer_small_links">
        <a href="">Cookie policy</a>
        <a href="">User agreement</a>
        <a href="">Community Guildnes</a>
       <router-link :to="{name: 'PrivacyPolicy'}">Privacy Policy</router-link>
        <router-link :to="{name: 'ConnectPolicy'}">CC-Connect Policy</router-link>
         <router-link :to="{name: 'TermsAndConditions'}">Terms and Conditions</router-link>
           <a href="./FAQ.pdf" target="_blank">FAQ</a>
      </div>
    </div>
    <div class="base">
      <p class="rights">© {{ getYear() }} Carrier Community | All rights reserved</p>
    </div>
  </div>
</template>
<script>
import moment from 'moment';

export default {
  name: 'Footer',
  methods: {
    getYear() {
      return moment().format('YYYY');
    },
  },
};
</script>

<style scoped>
.contacts {
  height: 65px;
  background-color: #343a40;
  display: flex;
  justify-content: center;
  align-items: center;
}
.contacts a{
  color: #7d7d7d;
  text-decoration: none;
}
.contacts a:hover {
  color: #7d7d7d;
}
.footer_small_links {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  color: #666666;
  font-size: 12px;
}
.footer_small_links > a {
  padding-left: 19px;
}
.base {
  height: 30px;
  background-color: #15181c;
  display: flex;
  justify-content: center;
  align-items: center;
}
.rights {
  font-family: Arial;
  font-size: 10px;
  text-align: left;
  color: #666666;
  margin: 0;
}
</style>
